export const RecordVI = {
    "assetConfig": {
        "codeStructure": "Cấu trúc mã",
        "codeStructureDetail1": "Sử dụng các từ khóa {keyword} để viết mã tự sinh theo format định sẵn",
        "codeStructureDetail2": "Xem danh sách từ khóa có thể sử dụng",
        "counting": "Bộ đếm tự tăng bắt đầu từ",
        "countingDetail": "Bộ đếm mã tự tăng có thể cài đặt từ 0 hoặc lớn hơn tùy ý",
        "allowedEdit": "Cho phép chỉnh sửa",
        "allowedEditDetail1": "Khi tính năng này được bật, người dùng có thể thay đổi mã",
        "allowedEditDetail2": "Hãy tắt nó nếu công ty bạn đã có quy định chuẩn về mã , tránh tình trạng xung đột mã giữa các đối tượng",
        "asset": "Mã cài đặt tài sản",
        "assign": "Mã cài đặt cấp phát",
        "recovery": "Mã cài đặt thu hồi",
        "labelAsset": "NHÃN TÀI SẢN",
        "titleModal": "Từ khóa mã tự động",
        "titleColumn1": "Từ khóa",
        "titleColumn2": "Mô tả",
        "titleModalLabel": "Tạo mới nhãn"
    },
    "employeeConfigLabel": {
        "benefit": "Quản lý phụ cấp",
        "contractType": "Loại hợp đồng",
        "employeeConfig": "Hồ sơ nhân sự",
        "employeeContractConfig": "Hợp đồng lao động",
        "fineConfig": "Quy định phạt 5s",
        "jobPosition": "Cài đặt vị trí công việc",
        "jobTitle": "Cài đặt chức vụ",
        "employmentType" : " Cài đặt hình thức làm việc",
        "workplace": "Cài đặt nơi làm việc",
        "welfare": "Cài đặt khen thưởng/phúc lợi",
        "categoryConfig": "Danh mục",
        "award": "Cài đặt khen thưởng/phúc lợi"
    },
    "employeeConfig": {
        "benefit": "Quản lý phụ cấp",

        "contractType": "Loại hợp đồng",

        "employeeConfig": "Hồ sơ nhân sự",
        "employeeConfigHeader": "Cài đặt hồ sơ nhân sự",
        "employeeConfigSettingPatternCode": "Cài đặt mã nhân sự",
        "codePattern": "Cấu trúc mã",
        "codePatternDetail": "Sử dụng các từ khóa {keyword} để viết mã tự sinh theo format định sẵn",
        "codePatternShow": "Xem danh sách từ khóa có thể sử dụng",
        "viewOrUpdateInfoSalary": "Quyền được xem/sửa thông tin lương, phụ cấp trong HSNS",
        "viewOrUpdateInfoSalaryDetail": "Những người có quyền này sẽ xem/sửa được lương và phụ cấp của phòng ban tương ứng",
        "viewOrUpdateInfoInsurance": "Quyền được xem/sửa thông tin bảo hiểm trong HSNS",
        "viewOrUpdateInfoInsuranceDetail": "Những người có quyền này sẽ xem/sửa được thông tin bảo hiểm của phòng ban tương ứng",
        "allowedUpdateInfo": "Cho phép nhân viên tự cập nhật thông tin cá nhân",
        "allowedFieldUpdate": "Các trường NV được phép cập nhật thông tin",
        "allowedFieldUpdateDetail": "Khi cài đặt xong, người dùng có thể cập nhật các trường dữ liệu này ở trang cá nhân. Tuy nhiên, nó chỉ được cập nhật vào dữ liệu khi HSNS được duyệt",
        "setting": "Cài đặt",
        "all": "Tất cả",
        "managerAll": "Quản lý tất cả",
        "company": "Quản lý công ty",
        "branch": "Quản lý chi nhánh",
        "department": "Quản lý phòng ban",
        "award": "Cài đặt khen thưởng / phúc lợi",
        "position": "Cài đặt vị trí công việc",
        "positiontitle": "Cài đặt chức vụ",
        "workplace": "Cài đặt nơi làm việc",
        "penance": "Cài đặt quy định phạt 5s",
        "countDescription": "Bộ đếm tự tăng dần của đối tượng, sử dụng {count} hoặc ngoài ra bạn có thể định dạng thêm các ký tự \"0\" phía trước, ví dụ {count,5} sẽ hiển thị 00005",
        "userPersonCode": "Mã nhân sự của người tạo",
        "userDepartmentCode": "Mã phòng ban của người tạo",
        "dateDescription1": "Lấy ra giá trị thời gian hiện tại, format theo nhu cầu.",
        "dateDescription2": "Ví dụ : {date, ddMMyyyy} sẽ hiển thị là 05122021.",
        "dateDescription3": "Các ký tự dùng để format bao gồm:",
        "dateDescription4": "dd: ngày với định dạng 2 chữ số",
        "dateDescription5": "MM: tháng với định dạng 2 chữ số",
        "dateDescription6": "yy: năm với định dạng 2 chữ số",
        "dateDescription7": "yyyy: năm với định dạng 4 chữ số",
        "departmentCode": "Mã phòng ban của nhân sự gán với hợp đồng",
        "personCode": "Mã nhân sự gán với hợp đồng",
        "contractCount": "Số hợp đồng của nhân sự được tạo hợp đồng, định dạng 2 chữ số.",

        "insuranceConfig": "Cài đặt bảo hiểm",
        "insuranceConfigConditionsForIncreaseInsurance": "Điều kiện tăng bảo hiểm",
        "closingDateForMonthlyIncrease": "Ngày chốt tăng hàng tháng",
        "conditionsForIncreaseInsurance1": "Tăng lao động đóng BHXH, BHYT, BHTN trong trường hợp này được hiểu là tăng số lượng người lao động tham gia đóng BHXH, BHYT, BHTN.",
        "conditionsForIncreaseInsurance2": "Những phát sinh tăng trước ngày này sẽ báo tăng tháng này, còn sau ngày này sẽ báo tăng tháng sau.",
        "signEmployeeContract": "Ký hợp đồng lao động",
        "backToWorkMaternity": "Nghỉ thai sản quay lại làm việc",
        "backToWorkUnpaid": "Nghỉ không lương theo quy định (đã báo giảm) quay trở lại làm việc",
        "incrementAmount": "Tăng mức đóng",
        "insuranceConfigConditionsForDecreaseInsurance": "Điều kiện giảm bảo hiểm",
        "closingDateForMonthlyDecrease": "Ngày chốt giảm hàng tháng",
        "conditionsForDecreaseInsurance1": "Giảm lao động đóng BHXH, BHYT, BHTN trong trường hợp này được hiểu là giảm số lượng người lao động tham gia đóng BHXH, BHYT, BHTN.",
        "conditionsForDecreaseInsurance2": "Những phát sinh giảm trước ngày này sẽ báo giảm tháng này, còn sau ngày này sẽ báo giảm tháng sau.",
        "decrementReSign": "Hợp đồng lao động được đóng bảo hiểm nghỉ việc",
        "offWorkMaternity": "Nghỉ thai theo chế độ",
        "decrementAmount": "Giảm mức đóng",
        "decrementAmountContent": "Đối với trường hợp người lao động không làm việc và không hưởng tiền lương quá số ngày nghỉ tối đa hàng tháng thì không đóng BHXH tháng đó. Thời gian này không được tính để hưởng BHXH.",
        "offWorkUnpaid": "Nghỉ không lương",
        "unpaidMaxDay": "Số ngày tối đa nghỉ không lương hàng tháng",
        "insuranceRate": "Tỷ lệ bảo hiểm",
        "insuranceRateContent": "Cài đặt này sẽ ứng với toàn bộ hồ sơ nhân sự",
        "insuranceRateFromMonth": "Từ tháng",
        "insuranceAmount": "Mức đóng",
        "socialInsuranceRate": "Bảo hiểm xã hội",
        "accidentInsuranceRate": "Bảo hiểm TNLĐ - BNN",
        "healthInsuranceRate": "Bảo hiểm y tế",
        "unemploymentInsuranceRate": "Bảo hiểm thất nghiệp",
        "totalInsuranceRate": "Tổng cộng",
        "placeholderAmount": "Số tiền",
        "placeholderCompany": "CTY",
        "placeholderEmployee": "NLĐ",
        "autoCalculate": "Tự động tính toán lại bảo hiểm từ tháng hiện tại",
        "autoCalculateContent": "Trong đó, các ô màu xám là số % người lao động chi trả",
        "employeeContractConfig": "Hợp đồng lao động",
        "employmentType" : " Cài đặt hình thức làm việc"

    },
    "penanceConfig": {
        "headingLabel": "Quy định phạt 5s",
        "active": "Hoạt động",
        "inactive": "Không hoạt động",
        "update": "Cập nhật",
        "penanceConfigColumns": {
            "name": "Lỗi vi phạm",
            "amount": "Số tiền",
            "status": "Trạng thái"
        }
    },
    "awardConfig": {
        "headingLabel": "Cài đặt khen thưởng / phúc lợi",
        "active": "Hoạt động",
        "inactive": "Không hoạt động",
        "update": "Cập nhật",
        "awardConfigColumns": {
            "name": "Tên hình thức",
            "amount": "Số tiền",
            "status": "Trạng thái",
            "desc": "Mô tả"
        }
    },
    "fineConfig": {
        "add": "Thêm mới quy định phạt"
    },
}